import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import ColumnConfigurationsVM from './ColumnConfigurationsVM';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../Common/TextConstants';
import ColumnConfigurationLookup from '../Models/Lookups/ColumnConfigurationLookup';
import ManageColumnSpecComponent from '../Components/ManageColumnSpecComponent';
import Loading from '../../../App/Components/Loading/Loading';
import { ColumnConfiguration, FileConfigurations } from '../../../AccessControl/Models/Commands/Security/Roles';

class ColumnConfigurationsParams {
    public fileSpecID = {};
    public fileSpecProps = {};
}

@observer
export default class ColumnConfigurationsView extends Views.ViewBase<ColumnConfigurationsVM, ColumnConfigurationsParams> {
    public static params = new ColumnConfigurationsParams();

    public initialise() {
        this.viewModel.initialise(Number(this.viewParams.fileSpecID.value), String(this.viewParams.fileSpecProps.value));
        this.viewModel.pageManager.refreshData();
    }

    constructor(props: unknown) {
        super("Column Configurations", ColumnConfigurationsVM, props);
    }

    public render() {
        return (
            <div>
                {(this.viewModel.taskRunner.isBusy) && <Loading />}
                {this.viewModel.showManageColumnComponent &&
                    <ManageColumnSpecComponent
                        viewModel={this.viewModel.manageColumnSpecComponentVM}
                        onSave={() => this.viewModel.saveColumnSpec()}
                        onCancel={() => this.viewModel.cancel()} />}

                {!this.viewModel.showManageColumnComponent &&
                    <Neo.Card title={TextConstants.Titles.ColumnConfiguration} className="m-1">
                        <div>
                            <Neo.Form model={this.viewModel.columnConfigurationSearchCriteria} onSubmit={() => this.viewModel.columnConfigurationSearchCriteria.meta.searchCriteria.value === "" ? this.viewModel.pageManager.refreshData() : this.viewModel.clearSearch()}>
                                {this.viewModel.authorisationService.hasRole(ColumnConfiguration.AddNew) &&
                                    <div className="row">
                                            <div className='col text-right'>
                                            <Neo.Button
                                                onClick={() => this.viewModel.addColumn()}
                                                variant="primary" size="sm"
                                            >{TextConstants.Buttons.AddColumn}</Neo.Button>
                                        </div>
                                    </div>
                                }                                
                                <div>
                                    <Neo.FormGroup bindContext={this.viewModel.columnConfigurationSearchCriteria.meta.fileTypeConcatenated} label={TextConstants.Labels.FileType}>
                                        <Neo.AutoCompleteDropDown
                                            itemSource={this.viewModel.fileGroupingFileSpecApiClient.getFileTypeListByCriteria}
                                            bind={this.viewModel.columnConfigurationSearchCriteria.meta.staticFileSpecID}
                                            bindDisplay={this.viewModel.columnConfigurationSearchCriteria.meta.fileTypeConcatenated}
                                            displayMember={"propertiesConcatenated"}
                                            onItemSelected={() => this.viewModel.pageManager.refreshData()}
                                            items={this.viewModel.fileGroupingFileSpecApiClient.getFileTypeListByCriteria(" ").then((arr) => arr.data.slice(0,10)
                                            .sort((x,y)=> x.propertiesConcatenated.localeCompare(y.propertiesConcatenated)))}
                                        />
                                    </Neo.FormGroup>
                                </div>
                                <div>
                                    <Neo.FormGroup label={TextConstants.Labels.SearchColumns}
                                        bind={this.viewModel.columnConfigurationSearchCriteria.meta.searchCriteria}
                                        suppressLabel={true}
                                        placeholder={TextConstants.PlaceHolder.SearchColumns}
                                        append={
                                            <Neo.Button className="btn-small" isSubmit variant="primary">
                                                <i className={`${this.viewModel.columnConfigurationSearchCriteria.meta.searchCriteria.value === "" ? "fa fa-search" : "fa fa-times-circle"}`} />
                                            </Neo.Button>}
                                    />
                                </div>
                            </Neo.Form>
                        </div>
                        <Neo.Pager pageManager={this.viewModel.pageManager} pageControlProps={{ pageSizeLabel: "Show: " }} >
                            <div className="horizontalScroll">
                                <NeoGrid.Grid<ColumnConfigurationLookup> className={"table-striped"}>
                                    {(item, meta) => (
                                        <NeoGrid.Row key={item.staticColumnSpecID}>
                                            <NeoGrid.Column display={meta.fileSpecPropertiesConcatenated} label={TextConstants.Labels.FileType} />
                                            <NeoGrid.Column display={meta.columnNumber} />
                                            <NeoGrid.Column display={meta.fileFieldName} />
                                            <NeoGrid.Column display={meta.databaseFieldName} label={TextConstants.Labels.TableColumnName} />
                                            <NeoGrid.Column display={meta.description} />
                                            <NeoGrid.Column display={meta.dataType} />
                                            <NeoGrid.Column display={meta.dateFormat} />
                                            <NeoGrid.Column display={meta.allowsNullsInd} label={TextConstants.Labels.AllowsNulls} />
                                            <NeoGrid.Column display={meta.isUniqueInd} label={TextConstants.Labels.UniqueValue} />
                                            <NeoGrid.Column display={meta.generatesTransactionRecordInd} label={TextConstants.Labels.GeneratesTransactionRecord} />
                                            <NeoGrid.Column display={meta.ignoreColumnInd} label={TextConstants.Labels.IgnoreColumn} />
                                            {this.viewModel.authorisationService.hasRole(ColumnConfiguration.Edit) &&
                                                <NeoGrid.ButtonColumn label={TextConstants.Labels.Edit} className="text-center">
                                                    <Neo.Button
                                                        onClick={() => this.viewModel.editColumnSpec(item)}
                                                        variant="primary" isOutline className="btn-small">
                                                        <i className="fa fa-edit"></i>
                                                    </Neo.Button>
                                                </NeoGrid.ButtonColumn>
                                            }
                                        </NeoGrid.Row>
                                    )}
                                </NeoGrid.Grid>
                            </div>
                        </Neo.Pager>

                        <div className="row pt-2">
                            {this.viewModel.authorisationService.hasRole(FileConfigurations.Access) &&
                                <div className="col-1">
                                    <Neo.Button
                                        className='col-8'
                                        onClick={() => this.viewModel.onBack()}
                                        variant="secondary" size="sm"                                        
                                    >{TextConstants.Buttons.Back}</Neo.Button>
                                </div>
                            }
                        </div>

                    </Neo.Card>
                }
            </div>
        );
    }
}